import React from "react";
import "./common.scss";

const Loader = ({ fullscreen = true, className = "" }) => {
  const containerClassName = fullscreen
    ? "loader-container"
    : "loader-inline-container";

  return (
    <div className={`${containerClassName} ${className}`.trim()}>
      <div className="loader"></div>
    </div>
  );
};
export default Loader;
